var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2475 1650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-5);}.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-6,.cls-77,.cls-79,.cls-8,.cls-88{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);filter:url(#luminosity-noclip-6);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);filter:url(#luminosity-noclip-7);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);filter:url(#luminosity-noclip-8);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{isolation:isolate;}.cls-10{opacity:0.72;fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12,.cls-13,.cls-62,.cls-63,.cls-66,.cls-70,.cls-92{mix-blend-mode:overlay;}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#New_Gradient_Swatch_1);}.cls-14,.cls-74{fill:#fff;}.cls-14{opacity:0;}.cls-15{fill:#f9fcfa;opacity:0.02;}.cls-16{fill:#f3f9f5;opacity:0.05;}.cls-17{fill:#edf7f0;opacity:0.07;}.cls-18{fill:#e6f4eb;opacity:0.1;}.cls-19{fill:#e0f1e6;opacity:0.12;}.cls-20{fill:#daeee1;opacity:0.15;}.cls-21{fill:#d4ebdc;opacity:0.17;}.cls-22{fill:#cee8d7;opacity:0.2;}.cls-23{fill:#c8e6d2;opacity:0.22;}.cls-24{fill:#c2e3cd;opacity:0.24;}.cls-25{fill:#bbe0c7;opacity:0.27;}.cls-26{fill:#b5ddc2;opacity:0.29;}.cls-27{fill:#afdabd;opacity:0.32;}.cls-28{fill:#a9d7b8;opacity:0.34;}.cls-29{fill:#a3d5b3;opacity:0.37;}.cls-30{fill:#9dd2ae;opacity:0.39;}.cls-31{fill:#97cfa9;opacity:0.41;}.cls-32{fill:#90cca4;opacity:0.44;}.cls-33{fill:#8ac99f;opacity:0.46;}.cls-34{fill:#84c69a;opacity:0.49;}.cls-35{fill:#7ec495;opacity:0.51;}.cls-36{fill:#78c190;opacity:0.54;}.cls-37{fill:#72be8b;opacity:0.56;}.cls-38{fill:#6bbb86;opacity:0.59;}.cls-39{fill:#65b881;opacity:0.61;}.cls-40{fill:#5fb57c;opacity:0.63;}.cls-41{fill:#59b377;opacity:0.66;}.cls-42{fill:#53b072;opacity:0.68;}.cls-43{fill:#4dad6d;opacity:0.71;}.cls-44{fill:#47aa68;opacity:0.73;}.cls-45{fill:#40a762;opacity:0.76;}.cls-46{fill:#3aa45d;opacity:0.78;}.cls-47{fill:#34a258;opacity:0.8;}.cls-48{fill:#2e9f53;opacity:0.83;}.cls-49{fill:#289c4e;opacity:0.85;}.cls-50{fill:#229949;opacity:0.88;}.cls-51{fill:#1c9644;opacity:0.9;}.cls-52{fill:#15933f;opacity:0.93;}.cls-53{fill:#0f913a;opacity:0.95;}.cls-54{fill:#098e35;opacity:0.98;}.cls-55{fill:#038b30;}.cls-56{fill:url(#linear-gradient-8);}.cls-57{fill:url(#linear-gradient-9);}.cls-58{fill:url(#New_Gradient_Swatch);}.cls-59{fill:#fae942;}.cls-60{fill:url(#linear-gradient-10);}.cls-61{fill:url(#linear-gradient-11);}.cls-62{fill:url(#linear-gradient-12);}.cls-64{fill:url(#linear-gradient-13);}.cls-65{fill:url(#linear-gradient-14);}.cls-66{opacity:0.6;fill:url(#linear-gradient-15);}.cls-67{fill:url(#New_Gradient_Swatch_1-2);}.cls-68{fill:url(#linear-gradient-16);}.cls-69{fill:url(#linear-gradient-17);}.cls-70{fill:url(#New_Gradient_Swatch_1-3);}.cls-71{fill:url(#linear-gradient-18);}.cls-72{fill:url(#linear-gradient-19);}.cls-73{fill:url(#linear-gradient-20);}.cls-75{fill:#fbe7c1;}.cls-76{mask:url(#mask-5);}.cls-77{opacity:0.2;fill:url(#linear-gradient-21);}.cls-78{mask:url(#mask-6);}.cls-79,.cls-88{opacity:0.3;}.cls-79{fill:url(#linear-gradient-22);}.cls-80{fill:url(#linear-gradient-23);}.cls-81{fill:url(#linear-gradient-24);}.cls-82{fill:url(#linear-gradient-25);}.cls-83{fill:#828282;}.cls-84{fill:url(#linear-gradient-26);}.cls-85{fill:url(#New_Gradient_Swatch_1-4);}.cls-86{fill:url(#linear-gradient-27);}.cls-87{mask:url(#mask-7);}.cls-88{fill:url(#linear-gradient-28);}.cls-89{fill:url(#linear-gradient-29);}.cls-90{fill:url(#linear-gradient-30);}.cls-91{mask:url(#mask-8);}.cls-92{fill:url(#New_Gradient_Swatch_1-5);}.cls-93{fill:#4bc70f;}.cls-94{fill:url(#New_Gradient_Swatch_1-6);}.cls-95{fill:url(#New_Gradient_Swatch_1-7);}.cls-96,.cls-99{fill:#f4c948;}.cls-97{fill:#f7e98b;}.cls-98{fill:#3dbc15;}.cls-99{opacity:0.78;}.cls-100{fill:url(#New_Gradient_Swatch_1-8);}.cls-101{fill:none;stroke:#077225;stroke-miterlimit:10;stroke-width:3px;}.cls-102{opacity:0.07;fill:url(#linear-gradient-31);}.cls-103{fill:url(#linear-gradient-32);}.cls-104{fill:url(#New_Gradient_Swatch_7);}.cls-105{filter:url(#luminosity-noclip-4);}.cls-106{filter:url(#luminosity-noclip-3);}.cls-107{filter:url(#luminosity-noclip-2);}.cls-108{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 1133.37,
    y: -9017,
    width: 582.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 1133.37,
    y: -9017,
    width: 582.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1477.49,
    y1: 1325.54,
    x2: 1469.29,
    y2: 1311.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1133.52,
    y: -9017,
    width: 582.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 1133.52,
    y: -9017,
    width: 582.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1328.51,
    y1: 1426.5,
    x2: 1341.01,
    y2: 1401.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 1166.67,
    y: -9017,
    width: 510.94,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 1166.67,
    y: -9017,
    width: 510.94,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 532.58,
    y1: 1444.84,
    x2: 1440.99,
    y2: 1216.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 1162.7,
    y: -9017,
    width: 510.94,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 1162.7,
    y: -9017,
    width: 510.94,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 528.61,
    y1: 1410.84,
    x2: 1437.02,
    y2: 1182.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1530.52,
    y1: 1588.35,
    x2: 960.19,
    y2: 351.87,
    gradientTransform: "translate(189.92 -374.38) rotate(17.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6be300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#048b30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3590.89,
    y1: -437.96,
    x2: -1328.5,
    y2: -437.96,
    gradientTransform: "matrix(-0.31, 0.95, 0.95, 0.31, 50.13, 3766.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d9e021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0e6a41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1324.6,
    y1: 1013.9,
    x2: 1255.71,
    y2: 832.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff7f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffce00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 1489.38,
    y1: 655.03,
    x2: 1457.24,
    y2: 570.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6be300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#048b30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1268.45,
    y1: 1138.58,
    x2: 1052.24,
    y2: 1138.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33b219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cad1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2999.14,
    y1: 2154.82,
    x2: 702.65,
    y2: 815.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4c948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch",
    x1: 1097.23,
    y1: 677.86,
    x2: 1074.94,
    y2: 638.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 920.58,
    y1: 1010.64,
    x2: 947.71,
    y2: 744.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#048b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6be300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 967.09,
    y1: 923.32,
    x2: 986.67,
    y2: 953.03,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 972.42,
    y1: 770.85,
    x2: 856.87,
    y2: 945.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 959.72,
    y1: 770.45,
    x2: 801.74,
    y2: 1009.12,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 843.63,
    y1: 836.8,
    x2: 685.64,
    y2: 1075.47,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 920.52,
    y1: 1011.15,
    x2: 947.65,
    y2: 745.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#038b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffe2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 1229.68,
    y1: 960.66,
    x2: 1263.64,
    y2: 727.17,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3055,
    y1: 1064.4,
    x2: -3038.21,
    y2: 1101.34,
    gradientTransform: "matrix(-0.97, 0, 0, 1, -1949.7, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#159927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#048b30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 942.92,
    y1: 1362.51,
    x2: 1087.79,
    y2: 833.97,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: 815.14,
    y1: 1843.19,
    x2: 1106.45,
    y2: 625.39,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 919.49,
    y1: 1125.65,
    x2: 941.5,
    y2: 1125.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 891.99,
    y1: 1140.24,
    x2: 913.95,
    y2: 1140.24,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 864.6,
    y1: 1154.78,
    x2: 886.46,
    y2: 1154.78,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 1133.37,
    y: 1125.69,
    width: 582.5,
    height: 285.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 1133.37,
    y: 1125.69,
    width: 582.5,
    height: 285.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1714.73,1154.52c-3-12.47-19.82-19.91-19.82-19.91l-17.45-8.92-54.12,40c-42.72,17.26-111.49,46.26-118.47,50.92-10,6.65-76.44,71.92-90.39,85.48s-24.51,30.36-28.54,33.59-2.78,1.34-12.28,15.84c-1.84,2.8-3.21,5-4.25,6.72h-52.49c.5-4.19.39-7.79-.72-10.09-4.74-9.91-33.54-39.82-54-41.15-7.35-.47-18.09-1.7-29.23-2.92l-67.88-37.79-20.77,13.72s-10.91,10.56-10.91,26.19c0,12.76,4.82,20.24,14.53,25.7s19.83,10.1,19.83,10.1l103.06,51.68,25.18,12.15a50.69,50.69,0,0,0,48.14-2.22l39.84-24L1692.8,1194.4a147.08,147.08,0,0,0,13-10C1714.86,1177,1717.72,1167,1714.73,1154.52Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1133.37,
    y1: 1272.29,
    x2: 1715.87,
    y2: 1272.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051e51"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 1133.52,
    y: 1125.69,
    width: 582.5,
    height: 285.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 1133.52,
    y: 1125.69,
    width: 582.5,
    height: 285.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1714.88,1154.52c-3-12.47-19.82-19.91-19.82-19.91l-17.45-8.92-54.12,40C1580.77,1183,1512,1212,1505,1216.66c-10,6.65-76.44,71.92-90.4,85.48s-24.5,30.36-28.53,33.59-2.78,1.34-12.28,15.84c-1.84,2.8-3.21,5-4.25,6.72h-52.49c.5-4.19.39-7.79-.72-10.09-4.75-9.91-33.54-39.82-54-41.15-7.35-.47-18.09-1.7-29.23-2.92l-67.88-37.79-20.77,13.72s-10.91,10.56-10.91,26.19c0,12.76,4.81,20.24,14.53,25.7s19.83,10.1,19.83,10.1l103.06,51.68,25.18,12.15a50.69,50.69,0,0,0,48.14-2.22l39.84-24L1693,1194.4a147.08,147.08,0,0,0,13-10C1715,1177,1717.87,1167,1714.88,1154.52Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1133.52,
    y1: 1272.76,
    x2: 1716.02,
    y2: 1272.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051e51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2005.56,
    y1: 1755.86,
    x2: 1409.88,
    y2: 1209.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe7c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 661.68,
    y1: 1883.45,
    x2: 2315.07,
    y2: 435.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f79a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1237.37,
    y1: 1177.75,
    x2: 2290.31,
    y2: 1177.75,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1422.1,
    y1: 1378.76,
    x2: 1399.87,
    y2: 1358.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c74ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: 1220.77,
    y1: 1326.71,
    x2: 1319.89,
    y2: 1342.46,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1221.75,
    y1: 1320.5,
    x2: 1320.87,
    y2: 1336.25,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 1166.67,
    y: 1078.36,
    width: 510.94,
    height: 285.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 1166.67,
    y: 1078.36,
    width: 510.94,
    height: 285.25,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1168.27,1277.85,1347,1362.71a9.34,9.34,0,0,0,8.77-.41l320.36-191a3.06,3.06,0,0,0-.23-5.38l-178.25-86.75a8.38,8.38,0,0,0-8,.35L1168,1272.92A2.8,2.8,0,0,0,1168.27,1277.85Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1525.29,
    y1: 1066.24,
    x2: 1319.1,
    y2: 1377.73,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1516.1,
    y1: 1179.67,
    x2: 1622.65,
    y2: 1091.3,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1584.48,
    y1: 1100.68,
    x2: 1668.51,
    y2: 1109.59,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 1162.7,
    y: 1044.36,
    width: 510.94,
    height: 285.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 1162.7,
    y: 1044.36,
    width: 510.94,
    height: 285.25,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1164.3,1243.85,1343,1328.71a9.34,9.34,0,0,0,8.77-.42l320.36-191a3.05,3.05,0,0,0-.23-5.37l-178.25-86.76a8.38,8.38,0,0,0-8,.35l-321.63,193.37A2.8,2.8,0,0,0,1164.3,1243.85Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 1418.17,
    y1: 1495.9,
    x2: 1418.17,
    y2: 1311.23,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 1513.68,
    y1: 1107.45,
    x2: 1342.01,
    y2: 1162.73,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: 1501.22,
    y1: 998.93,
    x2: 1350.32,
    y2: 1097.69,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: 1403.19,
    y1: 997.89,
    x2: 1312.11,
    y2: 1212.75,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -3942.38,
    y1: 64.36,
    x2: -2387.84,
    y2: 64.36,
    gradientTransform: "matrix(-0.31, 0.95, 0.95, 0.31, 50.13, 3766.3)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -2542.41,
    y1: -213.45,
    x2: -2542.01,
    y2: -213.45,
    gradientTransform: "matrix(-0.31, 0.95, 0.95, 0.31, 50.13, 3766.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff841f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff7f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ffce00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7",
    x1: -4011.23,
    y1: 367.71,
    x2: -3457.83,
    y2: 367.71,
    gradientTransform: "matrix(-0.31, 0.95, 0.95, 0.31, 50.13, 3766.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d9e021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0e6a41"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1435.82,1083.66c-19.38-49.88,43.61,94.4,95,79.66,515.25-147.67,221.39-522.21,31.41-468.86-48,13.47-251.44-22.72-288.71-205.5-17.58-86.18-63.92-166.77-122.85-232.07-66.38-73.55-170.82-111.61-268.55-95.29s-185,87.64-217.95,181.08c-32.46,92.1-13.17,193.1-3.27,290.26l.24,2.4c10.69,106.88-63.35,204-169.34,221.48a109,109,0,0,0-17,4.26c-48.2,16.16-82.08,63.22-91.05,113.25s4.19,102.07,27.6,147.2c36.81,70.94,322.4-41.65,390.35,1.79l318.65,164.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 453.46,
    cy: 1077.33,
    r: 275.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7",
    "data-name": 7
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1105.28,1207.85l362.58-215.3c7-4.17,12.72-15.37,12.73-25l.23-329.6c0-9.65-5.67-14.09-12.7-9.92L1105.54,843.33c-7,4.17-12.72,15.37-12.73,25l-.23,319.91C1092.57,1197.89,1098.26,1212,1105.28,1207.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1387,745.53l169.19-100.47c3.28-1.94,5.94-7.17,5.94-11.67l.11-153.79c0-4.5-2.65-6.57-5.93-4.63L1387.17,575.44c-3.28,1.94-5.94,7.17-5.94,11.67l-.11,149.27C1381.12,740.88,1383.77,747.47,1387,745.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1059.24,1502.08,610.1,1241.73c-61.44-35.62-53.62-97.64,17.47-138.52l379.78-218.39c71.1-40.88,178.55-45.15,240-9.53l449.14,260.35c61.45,35.62,53.62,97.64-17.47,138.52l-379.78,218.39C1228.14,1533.43,1120.69,1537.7,1059.24,1502.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1059.87,1500l-446.1-258.59c-61-35.38-53.26-97,17.36-137.59l377.2-216.9c70.62-40.61,177.35-44.85,238.38-9.47L1692.81,1136c61,35.38,53.26,97-17.36,137.59l-377.2,216.9C1227.63,1531.1,1120.91,1535.34,1059.87,1500Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1060.51,1497.84,617.44,1241c-60.62-35.14-52.9-96.32,17.24-136.65l374.64-215.43c70.14-40.33,176.13-44.54,236.75-9.4l443.07,256.83c60.62,35.14,52.9,96.32-17.24,136.65l-374.64,215.43C1227.12,1528.77,1121.13,1533,1060.51,1497.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1061.14,1495.73l-440-255.08c-60.2-34.9-52.54-95.66,17.12-135.71l372.08-214c69.65-40.05,174.92-44.23,235.13-9.34l440,255.08c60.2,34.9,52.54,95.66-17.12,135.71l-372.08,214C1226.62,1526.44,1121.35,1530.62,1061.14,1495.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1061.78,1493.61l-437-253.32c-59.79-34.65-52.18-95,17-134.77L1011.29,893c69.18-39.77,173.72-43.93,233.51-9.27l437,253.32c59.79,34.65,52.18,95-17,134.77l-369.51,212.49C1226.11,1524.11,1121.57,1528.27,1061.78,1493.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1062.41,1491.49l-434-251.55c-59.37-34.42-51.81-94.34,16.88-133.85l366.95-211c68.69-39.51,172.51-43.63,231.89-9.21l434,251.55c59.37,34.42,51.81,94.34-16.88,133.85l-367,211C1225.61,1521.79,1121.79,1525.91,1062.41,1491.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1063.05,1489.37,632.12,1239.58c-59-34.18-51.45-93.68,16.76-132.91l364.38-209.53c68.22-39.23,171.31-43.32,230.27-9.14l430.93,249.79c59,34.18,51.45,93.68-16.76,132.91l-364.38,209.53C1225.1,1519.46,1122,1523.55,1063.05,1489.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1063.68,1487.26l-427.89-248c-58.54-33.94-51.09-93,16.64-132l361.82-208.06c67.74-39,170.1-43,228.65-9.08l427.89,248c58.54,33.94,51.09,93-16.64,132l-361.82,208.06C1224.6,1517.13,1122.23,1521.19,1063.68,1487.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1064.32,1485.14,639.46,1238.86c-58.13-33.69-50.73-92.36,16.53-131l359.25-206.58c67.25-38.68,168.89-42.72,227-9l424.86,246.28c58.13,33.69,50.73,92.36-16.52,131l-359.26,206.59C1224.09,1514.8,1122.45,1518.84,1064.32,1485.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1065,1483,643.13,1238.5c-57.71-33.45-50.37-91.7,16.41-130.1l356.68-205.1c66.78-38.4,167.69-42.41,225.41-8.95l421.82,244.52c57.71,33.45,50.37,91.7-16.41,130.1l-356.68,205.1C1223.58,1512.47,1122.67,1516.48,1065,1483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1065.59,1480.91,646.8,1238.14c-57.3-33.21-50-91,16.29-129.16l354.12-203.63c66.29-38.12,166.48-42.1,223.78-8.89l418.79,242.77c57.3,33.21,50,91-16.29,129.16L1289.37,1472C1223.08,1510.14,1122.89,1514.12,1065.59,1480.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1066.23,1478.79l-415.76-241c-56.88-33-49.64-90.39,16.17-128.23L1018.19,907.4c65.82-37.84,165.28-41.79,222.16-8.82l415.76,241c56.89,33,49.64,90.39-16.17,128.23L1288.39,1470C1222.57,1507.81,1123.11,1511.76,1066.23,1478.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1066.86,1476.67,654.14,1237.43c-56.47-32.73-49.28-89.72,16.05-127.29l349-200.68c65.33-37.57,164.07-41.49,220.54-8.76l412.72,239.24c56.47,32.73,49.28,89.73-16,127.29l-349,200.68C1222.07,1505.48,1123.33,1509.4,1066.86,1476.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1067.5,1474.56,657.81,1237.07c-56.06-32.49-48.92-89.06,15.93-126.36l346.43-199.2c64.85-37.29,162.86-41.19,218.91-8.69l409.69,237.48c56.06,32.49,48.92,89.06-15.93,126.36l-346.42,199.2C1221.56,1503.15,1123.55,1507.05,1067.5,1474.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1068.13,1472.44,661.48,1236.71c-55.64-32.25-48.56-88.4,15.81-125.42l343.86-197.73c64.37-37,161.66-40.88,217.3-8.63l406.66,235.73c55.63,32.25,48.55,88.4-15.82,125.42l-343.86,197.73C1221.06,1500.83,1123.77,1504.69,1068.13,1472.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1068.77,1470.32l-403.62-234c-55.23-32-48.2-87.74,15.7-124.48l341.29-196.26c63.89-36.74,160.45-40.57,215.67-8.56l403.63,234c55.22,32,48.19,87.74-15.7,124.48l-341.3,196.26C1220.55,1498.5,1124,1502.33,1068.77,1470.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1069.4,1468.2,668.81,1236c-54.8-31.77-47.83-87.08,15.59-123.54l338.72-194.78c63.42-36.47,159.25-40.27,214.06-8.5l400.59,232.21c54.8,31.77,47.83,87.08-15.59,123.54L1283.46,1459.7C1220.05,1496.17,1124.21,1500,1069.4,1468.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1070,1466.09,672.48,1235.64C618.09,1204.11,625,1149.21,688,1113l336.16-193.3c62.93-36.19,158-40,212.43-8.44l397.56,230.45c54.39,31.53,47.46,86.43-15.47,122.62l-336.16,193.3C1219.54,1493.84,1124.43,1497.62,1070,1466.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1070.67,1464,676.15,1235.28c-54-31.29-47.1-85.77,15.35-121.68l333.59-191.83c62.46-35.91,156.84-39.66,210.82-8.37l394.52,228.69c54,31.29,47.1,85.77-15.35,121.68L1281.49,1455.6C1219,1491.51,1124.65,1495.26,1070.67,1464Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1071.31,1461.85,679.82,1234.92c-53.56-31.05-46.74-85.11,15.23-120.74l331-190.36c62-35.63,155.63-39.35,209.19-8.3l391.49,226.93c53.56,31,46.74,85.11-15.23,120.74l-331,190.36C1218.53,1489.18,1124.87,1492.9,1071.31,1461.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1071.94,1459.74,683.49,1234.56c-53.14-30.81-46.38-84.44,15.11-119.8l328.47-188.88c61.49-35.36,154.42-39,207.57-8.25l388.45,225.18c53.15,30.81,46.38,84.45-15.11,119.81l-328.47,188.87C1218,1486.85,1125.09,1490.54,1071.94,1459.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1072.58,1457.62,687.16,1234.2c-52.73-30.56-46-83.78,15-118.87l325.9-187.4c61-35.08,153.22-38.75,206-8.18l385.42,223.42c52.73,30.56,46,83.78-15,118.87l-325.9,187.4C1217.52,1484.52,1125.31,1488.19,1072.58,1457.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1073.22,1455.5,690.83,1233.84c-52.32-30.32-45.66-83.12,14.87-117.93L1029,930c60.53-34.8,152-38.44,204.33-8.11l382.38,221.66c52.32,30.32,45.66,83.12-14.87,117.93l-323.34,185.93C1217,1482.2,1125.53,1485.83,1073.22,1455.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1073.85,1453.38,694.5,1233.49c-51.9-30.09-45.29-82.47,14.76-117L1030,932c60-34.54,150.81-38.14,202.71-8l379.35,219.89c51.9,30.09,45.3,82.47-14.76,117l-320.76,184.46C1216.51,1479.87,1125.75,1483.47,1073.85,1453.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1074.49,1451.27,698.17,1233.13c-51.49-29.85-44.93-81.81,14.64-116.06l318.2-183c59.57-34.26,149.6-37.83,201.09-8l376.31,218.14c51.49,29.85,44.93,81.81-14.64,116.07l-318.2,183C1216,1477.54,1126,1481.11,1074.49,1451.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1075.12,1449.15,701.84,1232.77c-51.07-29.6-44.57-81.15,14.52-115.13L1032,936.14c59.09-34,148.39-37.52,199.46-7.92l373.28,216.38c51.07,29.6,44.57,81.15-14.52,115.13l-315.64,181.5C1215.5,1475.21,1126.19,1478.75,1075.12,1449.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1075.76,1447,705.51,1232.41c-50.66-29.36-44.21-80.49,14.4-114.19l313.07-180c58.61-33.7,147.19-37.22,197.84-7.85L1601.07,1145c50.66,29.36,44.21,80.49-14.4,114.19l-313.07,180C1215,1472.88,1126.41,1476.4,1075.76,1447Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1076.39,1444.92,709.18,1232.05c-50.24-29.12-43.85-79.83,14.28-113.25L1034,940.25c58.13-33.43,146-36.92,196.22-7.8l367.21,212.87c50.24,29.12,43.85,79.83-14.28,113.25l-310.51,178.55C1214.48,1470.55,1126.63,1474,1076.39,1444.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1077,1442.8,712.85,1231.7c-49.83-28.89-43.49-79.17,14.16-112.33L1035,942.3c57.65-33.15,144.78-36.61,194.6-7.73l364.18,211.11c49.83,28.88,43.49,79.17-14.16,112.32l-307.94,177.07C1214,1468.22,1126.85,1471.68,1077,1442.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1077.66,1440.68,716.52,1231.34c-49.41-28.65-43.12-78.51,14-111.39l305.38-175.6c57.17-32.87,143.57-36.3,193-7.66L1590.06,1146c49.41,28.65,43.13,78.51-14,111.39L1270.64,1433C1213.47,1465.89,1127.07,1469.32,1077.66,1440.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1078.3,1438.57,720.19,1231c-49-28.4-42.76-77.85,13.93-110.45L1036.93,946.4c56.68-32.59,142.36-36,191.35-7.59l358.11,207.58c49,28.4,42.76,77.85-13.93,110.45L1269.66,1431C1213,1463.56,1127.29,1467,1078.3,1438.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1078.93,1436.45,723.86,1230.62c-48.58-28.16-42.4-77.19,13.81-109.51l300.24-172.65c56.21-32.32,141.16-35.7,189.74-7.54l355.08,205.83c48.58,28.16,42.39,77.19-13.82,109.51l-300.24,172.65C1212.46,1461.24,1127.51,1464.61,1078.93,1436.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1079.57,1434.33l-352-204.07c-48.17-27.92-42-76.53,13.69-108.58L1038.9,950.51c55.73-32,139.95-35.39,188.11-7.47l352,204.07c48.16,27.92,42,76.53-13.7,108.58l-297.68,171.17C1212,1458.91,1127.73,1462.25,1079.57,1434.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1080.2,1432.21l-349-202.31c-47.75-27.68-41.67-75.87,13.58-107.64l295.11-169.7c55.25-31.77,138.75-35.08,186.5-7.4l349,202.31c47.75,27.68,41.67,75.87-13.58,107.64l-295.11,169.7C1211.45,1456.58,1128,1459.89,1080.2,1432.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1080.84,1430.1l-346-200.55c-47.33-27.44-41.31-75.22,13.46-106.71l292.55-168.23c54.77-31.49,137.54-34.78,184.87-7.34l346,200.56c47.33,27.43,41.31,75.21-13.46,106.7l-292.55,168.23C1210.94,1454.25,1128.17,1457.54,1080.84,1430.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1081.47,1428,738.53,1229.19c-46.92-27.2-40.94-74.56,13.34-105.77l290-166.75c54.29-31.22,136.34-34.48,183.26-7.28l342.94,198.79c46.92,27.2,41,74.56-13.34,105.77l-290,166.75C1210.44,1451.92,1128.39,1455.18,1081.47,1428Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1082.11,1425.86l-339.91-197c-46.5-27-40.58-73.89,13.22-104.84l287.42-165.27c53.81-30.94,135.13-34.17,181.63-7.21l339.91,197c46.5,27,40.58,73.9-13.22,104.84l-287.42,165.27C1209.93,1449.59,1128.61,1452.82,1082.11,1425.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1082.75,1423.75,745.87,1228.47c-46.09-26.72-40.22-73.23,13.11-103.9l284.85-163.8c53.32-30.66,133.92-33.86,180-7.15l336.87,195.28c46.09,26.72,40.22,73.23-13.1,103.9l-284.86,163.8C1209.43,1447.26,1128.83,1450.46,1082.75,1423.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1083.38,1421.63,749.54,1228.11c-45.67-26.47-39.86-72.57,13-103l282.28-162.32c52.85-30.39,132.72-33.56,178.39-7.09L1557,1149.26c45.67,26.47,39.86,72.57-13,103l-282.28,162.32C1208.92,1444.93,1129.06,1448.11,1083.38,1421.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1084,1419.51,753.21,1227.75c-45.26-26.23-39.5-71.91,12.87-102L1045.8,964.88c52.36-30.11,131.51-33.26,176.76-7l330.81,191.76c45.26,26.23,39.5,71.91-12.87,102l-279.72,160.85C1208.42,1442.6,1129.28,1445.75,1084,1419.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1084.65,1417.39l-327.77-190c-44.84-26-39.14-71.26,12.75-101.1l277.15-159.37c51.89-29.84,130.3-32.95,175.15-6.95l327.77,190c44.85,26,39.14,71.25-12.75,101.09L1259.8,1410.44C1207.91,1440.28,1129.5,1443.39,1084.65,1417.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1085.29,1415.28,760.55,1227c-44.43-25.76-38.77-70.6,12.63-100.16L1047.77,969c51.41-29.56,129.09-32.64,173.52-6.89L1546,1150.33c44.43,25.76,38.78,70.6-12.63,100.16l-274.59,157.9C1207.41,1438,1129.72,1441,1085.29,1415.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1626.27,1143.35l-.35-64.9-63.4-.32L1229.4,885c-49.72-28.82-136.65-25.37-194.18,7.71L728,1069.42c-2.52,1.45-4.91,2.94-7.23,4.46l-40.42-.21v60.14h0c.39,17.86,11.38,34.89,33.47,47.69l363.38,210.64c49.72,28.82,136.66,25.37,194.18-7.71l307.26-176.69c32-18.38,48.1-42,47.61-64.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1077.2,1332,713.82,1121.37c-49.71-28.82-43.39-79,14.14-112.08L1035.22,832.6c57.53-33.07,144.46-36.53,194.18-7.71l363.38,210.65c49.71,28.81,43.39,79-14.14,112.07L1271.38,1324.3C1213.86,1357.38,1126.92,1360.83,1077.2,1332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1313.53,494.67,1231,446.8c-5.84-3.38-11.2-3.73-15.39-1.57h0l-.21.12L880.73,638.18l114.21,434.6,332.94-191.85c5.63-2.67,9.26-9.73,9.28-20l.57-319.77C1337.76,523.23,1326.93,502.44,1313.53,494.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M979.38,1071.3l-82.56-47.86c-13.4-7.77-24.24-28.57-24.21-46.45l.57-319.78c0-17.88,10.92-26.08,24.32-18.32l82.56,47.87c13.4,7.77,24.24,28.56,24.21,46.45L1003.7,1053C1003.67,1070.87,992.78,1079.07,979.38,1071.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M962.8,1033.5,910,1002.87c-8.58-5-15.51-18.28-15.49-29.73l.18-285.75c0-11.44,7-16.69,15.56-11.72l52.85,30.63c8.57,5,15.51,18.28,15.49,29.73l-.19,285.75C978.34,1033.23,971.38,1038.48,962.8,1033.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M935.71,989.43c-8.58-5-15.52-18.28-15.5-29.72l.18-278.09-10.15-5.89c-8.58-5-15.55.28-15.57,11.73l-.18,285.75c0,11.44,6.92,24.75,15.49,29.72l52.84,30.64c8.58,5,15.55-.28,15.57-11.73v-7.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M930.9,1052.23l-52.85-30.64c-8.57-5-15.51-18.28-15.49-29.73l.18-285.75c0-11.44,7-16.69,15.57-11.72L931.15,725c8.58,5,15.51,18.28,15.49,29.73l-.18,285.75C946.44,1052,939.47,1057.2,930.9,1052.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M913.22,1075.36a17.23,17.23,0,0,1-8.59-2.53l-52.85-30.63c-10-5.83-17.89-20.7-17.87-33.87l.19-285.75c0-7.77,2.85-13.86,7.78-16.7,4.38-2.5,9.68-2.2,15,.85l52.84,30.64c10.05,5.82,17.9,20.69,17.87,33.86L927.36,1057c0,7.77-2.85,13.86-7.79,16.7A12.62,12.62,0,0,1,913.22,1075.36Zm-65-361.59a3.17,3.17,0,0,0-1.62.4c-1.44.83-3,3.48-3,8.42l-.19,285.75c0,9.74,6,21.46,13.11,25.59l52.85,30.64c1.27.73,3.67,1.83,5.39.83,1.45-.83,3-3.49,3-8.43L918,771.22c0-9.74-6-21.46-13.11-25.59L852,715A8.13,8.13,0,0,0,848.26,713.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M797.13,1141.71a17,17,0,0,1-8.59-2.53l-52.84-30.63c-10.05-5.82-17.9-20.7-17.88-33.87L718,788.93c0-7.77,2.86-13.85,7.79-16.69,4.38-2.51,9.68-2.21,15,.84l52.84,30.64c10,5.82,17.9,20.7,17.87,33.86l-.18,285.75c0,7.78-2.85,13.86-7.79,16.7A12.65,12.65,0,0,1,797.13,1141.71Zm-65-361.59a3.11,3.11,0,0,0-1.61.4c-1.45.83-3,3.48-3,8.43l-.18,285.74c0,9.75,6,21.47,13.11,25.6l52.85,30.63c1.27.73,3.65,1.83,5.39.83,1.44-.83,3-3.48,3-8.43l.18-285.75c0-9.74-6-21.46-13.11-25.59L736,781.35A8.13,8.13,0,0,0,732.17,780.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M962.74,1034l-52.85-30.63c-8.57-5-15.51-18.28-15.49-29.73l.18-285.75c0-11.44,7-16.69,15.57-11.72L963,706.81c8.58,5,15.51,18.28,15.49,29.73l-.18,285.75C978.28,1033.74,971.31,1039,962.74,1034Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1268.05,736V720.08q-3.73,2.25-8.37,4.91l-4.17,2.4v15.84l-13.25,7.64V735L1230,742.09,1230.1,626l12.24-7.06V603.08l13.25-7.64v15.84l9.33-5.38q1.66-1,3.21-1.77V588.21l13.25-7.64v17.27a13.18,13.18,0,0,1,8-.11,12.28,12.28,0,0,1,6.71,5.83q2.67,4.52,2.66,12a47.31,47.31,0,0,1-3.31,16.87,51.9,51.9,0,0,1-9,15.37q8-1.5,12.24,3.48t4.27,15a58.6,58.6,0,0,1-2.78,17,62.38,62.38,0,0,1-7.58,16.37,46.88,46.88,0,0,1-11.36,12v16.63Zm-20.4-54.67,0,31,16.28-9.38q9.51-5.49,12.06-7.67a24.1,24.1,0,0,0,6.39-8.31,25.85,25.85,0,0,0,2.48-11.29c0-3.48-.64-6.07-1.9-7.77a5.58,5.58,0,0,0-5.5-2.14q-3.59.4-15.59,7.33Zm0-46.17V662l11.52-6.64q10.29-5.94,12.78-7.77a23.92,23.92,0,0,0,7.11-8.25,22.46,22.46,0,0,0,2.58-10.56q0-5.38-2.22-7.46t-6.62-.26q-2.61,1.11-15,8.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1275.87,741.39V725.47q-3.75,2.24-8.38,4.91l-4.16,2.4v15.84l-13.25,7.64V740.41l-12.24,7.06.07-116.11,12.25-7.05V608.46l13.25-7.63,0,15.84,9.34-5.38c1.1-.64,2.17-1.23,3.2-1.78l0-15.91,13.25-7.64,0,17.26a13.33,13.33,0,0,1,8-.11,12.29,12.29,0,0,1,6.71,5.83q2.67,4.51,2.67,12a47.57,47.57,0,0,1-3.31,16.87,51.9,51.9,0,0,1-9,15.37q8-1.5,12.24,3.47t4.26,15a58.3,58.3,0,0,1-2.77,17,62.85,62.85,0,0,1-7.58,16.37,47.38,47.38,0,0,1-11.36,12v16.63Zm-20.4-54.67,0,31,16.29-9.39q9.49-5.48,12.06-7.66a24.36,24.36,0,0,0,6.39-8.32,25.63,25.63,0,0,0,2.47-11.28q0-5.24-1.89-7.78a5.58,5.58,0,0,0-5.5-2.14q-3.58.42-15.59,7.33Zm0-46.18,0,26.86,11.53-6.65q10.27-5.93,12.78-7.76a23.79,23.79,0,0,0,7.1-8.25,22.35,22.35,0,0,0,2.59-10.56q0-5.38-2.22-7.47c-1.49-1.38-3.69-1.47-6.62-.26q-2.62,1.11-15,8.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M815.11,1350l-.6-338.93c0-10,5.89-21.53,13.15-25.84l374.7-222.5c3.14-1.86,6-2,8.23-.8l.05-.08,9.24,5.82-4.41,17.2-.22,328.72c0,10-5.9,21.53-13.16,25.84L831.37,1367.7h0l-12-7v0C816.76,1358.94,815.1,1355.24,815.11,1350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M836.19,1367.5l374.7-222.5c7.26-4.31,13.15-15.88,13.16-25.85l.23-340.62c0-10-5.86-14.55-13.12-10.24l-374.7,222.5c-7.26,4.31-13.15,15.88-13.15,25.85l-.24,330.6C823.06,1357.2,828.93,1371.81,836.19,1367.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1211.16,768.29l-374.7,222.5c-7.26,4.31-13.15,15.88-13.15,25.85l-.24,330.6c0,10,5.86,24.57,13.12,20.26l110.49-65.61h0s55-145.25,127.12-237.47c52.92-67.61,118.91-115,150.38-135.45l.1-150.44C1224.29,768.57,1218.42,764,1211.16,768.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M919.49,1098.92l13.53-8.09c4.62-2.76,8.38-.78,8.39,4.44l.09,43.91c0,5.22-3.73,11.68-8.35,14.45l-13.53,8.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "913.96 1165.11 892.12 1178.16 891.99 1115.37 913.83 1102.31 913.96 1165.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M873,1126.75l13.38-8,.13,62.8-13.38,8c-4.62,2.77-8.38.78-8.39-4.44l-.09-43.91C864.59,1136,868.33,1129.52,873,1126.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1016.83,1015.32c-1.34.76-2,.22-2-1.55l.34-55.08a4.17,4.17,0,0,1,2.05-3.87l.19-.11c1.34-.76,2-.22,2,1.55l-.17,26.61c2.58-5.52,6.35-10.29,10.63-12.72,8-4.54,14.48.45,14.41,11.05-.06,10.42-6.68,23.22-14.65,27.75-4.27,2.44-8,1.86-10.55-.83v3.22a4.15,4.15,0,0,1-2.06,3.86Zm23-31.59c.05-7.54-4.19-11.29-9.86-8.06s-10.49,12.14-10.54,19.67c0,7.38,4.82,11.11,10.37,7.95S1039.79,991.1,1039.83,983.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1050.55,947.41a7.25,7.25,0,0,1,3.09-5.64c1.59-.91,3,.16,3,2.19a7.28,7.28,0,0,1-3,5.77C1051.87,950.72,1050.54,949.7,1050.55,947.41Zm2.63,47.22c-1.34.76-2,.22-2-1.55l.2-31.86a4.17,4.17,0,0,1,2.05-3.87l.39-.22c1.33-.76,2-.22,2,1.55l-.2,31.86a4.21,4.21,0,0,1-2,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1075,950.21l-4.27,2.44-.19,29.39a4.19,4.19,0,0,1-2,3.88l-.19.11c-1.34.76-2,.22-2-1.55l.19-29.4-2.17,1.23c-1.34.76-2,.23-2-1.55a4,4,0,0,1,2.06-3.62l2.17-1.23.07-11.95a4.18,4.18,0,0,1,2.06-3.87l.19-.11c1.34-.76,2-.23,2,1.55l-.07,12,4.27-2.43c1.34-.77,2-.31,2,1.38A4.1,4.1,0,0,1,1075,950.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1105.5,939.78a1.72,1.72,0,0,1-2.48-.37c-1.76-2.2-4.62-2.68-7.93-.79-5.68,3.22-10.12,11.91-10.16,19.45,0,7.37,4.31,11.39,10,8.16,3.32-1.89,6.2-5.72,8-10a6.24,6.24,0,0,1,2.5-3.2l.63-.36c1.53-.87,2.29,0,1.52,2.35-2.53,7.17-7.33,13.8-12.69,16.84-8,4.54-14.48-.79-14.41-11.21.06-10.59,6.68-23.05,14.65-27.59,5.29-3,9.92-1.85,12.44,2.37.82,1.4,0,3.19-1.55,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1113.18,942c.07-10.59,6.69-23.06,14.66-27.59s14.48.45,14.42,11c-.07,10.42-6.69,23.23-14.66,27.77S1113.12,952.41,1113.18,942Zm4.47-2.54c-.05,7.37,4.31,11.39,10,8.16s10.12-12.26,10.17-19.63c0-7.54-4.32-11.22-10-8S1117.69,931.91,1117.65,939.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1148.51,891.66a7.24,7.24,0,0,1,3.08-5.64c1.6-.91,3,.16,3,2.19a7.29,7.29,0,0,1-3,5.78C1149.82,895,1148.5,894,1148.51,891.66Zm2.63,47.22c-1.34.76-2,.23-2-1.55l.2-31.86a4.18,4.18,0,0,1,2.06-3.87l.38-.21c1.34-.77,2-.24,2,1.54l-.2,31.86a4.19,4.19,0,0,1-2.06,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1164.6,931.22c-1.34.76-2,.23-2-1.55l.2-31.85a4.2,4.2,0,0,1,2.06-3.88l.19-.1c1.34-.77,2-.23,2,1.54v1.78a23.93,23.93,0,0,1,9.21-10.31c8-4.57,11.45-1.78,11.38,10.08l-.12,18.55a4.19,4.19,0,0,1-2,3.87l-.2.11c-1.34.77-2,.23-2-1.55l.11-18.55c.05-7.38-2.48-9.56-7.13-6.91-5.68,3.06-9.21,9.29-9.26,17.67l-.11,17.12a4.17,4.17,0,0,1-2,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M872.06,1301.62c-5.75,3.43-8.57-.15-8.69-9-.12-8.68,2.56-15.76,8.32-19.19s8.57.39,8.69,9.07C880.5,1291.34,877.82,1298.2,872.06,1301.62Zm-.34-25.44c-4.47,2.67-6.4,8.27-6.31,15.2.1,7.12,2.14,10.13,6.62,7.46s6.4-8,6.31-15.16C878.24,1276.75,876.2,1273.52,871.72,1276.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M891.05,1290.32c-5.75,3.43-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.32-19.19s8.57.38,8.69,9.06C899.49,1280,896.81,1286.9,891.05,1290.32Zm-.34-25.44c-4.48,2.66-6.4,8.27-6.31,15.2.09,7.12,2.14,10.13,6.61,7.46s6.41-8,6.32-15.16C897.23,1265.45,895.19,1262.22,890.71,1264.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M910,1279c-5.75,3.42-8.57-.16-8.69-9-.12-8.69,2.56-15.77,8.31-19.19s8.58.38,8.69,9.06C918.47,1268.74,915.8,1275.59,910,1279Zm-.34-25.44c-4.48,2.67-6.4,8.26-6.31,15.19.09,7.13,2.14,10.13,6.61,7.47s6.41-8,6.32-15.16C916.22,1254.15,914.18,1250.91,909.7,1253.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M929,1267.71c-5.76,3.43-8.58-.15-8.69-9-.12-8.68,2.56-15.76,8.31-19.19s8.58.39,8.69,9.07C937.46,1257.43,934.78,1264.29,929,1267.71Zm-.34-25.44c-4.48,2.67-6.4,8.27-6.31,15.2.09,7.12,2.13,10.13,6.61,7.46s6.41-8,6.31-15.16C935.21,1242.84,933.16,1239.61,928.69,1242.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M956.52,1251.35c-5.76,3.43-8.58-.16-8.69-9-.12-8.68,2.56-15.76,8.31-19.19s8.58.38,8.7,9.06C965,1241.07,962.27,1247.92,956.52,1251.35Zm-.34-25.44c-4.48,2.67-6.41,8.27-6.31,15.19.09,7.13,2.13,10.13,6.61,7.47s6.41-8,6.31-15.16C962.7,1226.48,960.66,1223.24,956.18,1225.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M975.51,1240.05c-5.76,3.42-8.58-.16-8.7-9-.11-8.68,2.57-15.77,8.32-19.19s8.58.38,8.69,9.06C983.94,1229.77,981.26,1236.62,975.51,1240.05Zm-.34-25.44c-4.48,2.66-6.41,8.26-6.31,15.19.09,7.12,2.13,10.13,6.61,7.47s6.41-8,6.31-15.16C981.69,1215.18,979.65,1211.94,975.17,1214.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M994.49,1228.75c-5.75,3.42-8.57-.17-8.69-9-.12-8.68,2.56-15.76,8.32-19.18s8.58.38,8.69,9.06C1002.93,1218.46,1000.25,1225.32,994.49,1228.75Zm-.34-25.44c-4.47,2.66-6.4,8.26-6.3,15.19.09,7.12,2.13,10.13,6.61,7.46s6.4-8,6.31-15.16C1000.68,1203.88,998.63,1200.64,994.15,1203.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1013.48,1217.44c-5.75,3.43-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.32-19.19s8.57.38,8.69,9.06C1021.92,1207.16,1019.24,1214,1013.48,1217.44Zm-.34-25.44c-4.47,2.67-6.4,8.27-6.31,15.19.1,7.13,2.14,10.13,6.61,7.47s6.41-8,6.32-15.16C1019.67,1192.57,1017.62,1189.33,1013.14,1192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1041,1201.08c-5.75,3.42-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.31-19.18s8.58.38,8.7,9.06C1049.41,1190.79,1046.73,1197.65,1041,1201.08Zm-.34-25.44c-4.48,2.66-6.4,8.26-6.31,15.19.1,7.12,2.14,10.13,6.61,7.46s6.41-8,6.32-15.16C1047.16,1176.21,1045.11,1173,1040.63,1175.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1060,1189.77c-5.76,3.43-8.57-.15-8.69-9-.12-8.68,2.56-15.76,8.31-19.19s8.58.38,8.7,9.06C1068.4,1179.49,1065.71,1186.35,1060,1189.77Zm-.34-25.44c-4.48,2.67-6.4,8.27-6.31,15.2.1,7.12,2.14,10.13,6.61,7.46s6.41-8,6.32-15.16C1066.14,1164.91,1064.1,1161.67,1059.62,1164.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1079,1178.47c-5.76,3.43-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.31-19.19s8.58.38,8.7,9.07C1087.38,1168.19,1084.7,1175,1079,1178.47Zm-.34-25.44c-4.48,2.67-6.4,8.27-6.31,15.19.09,7.13,2.13,10.13,6.61,7.47s6.41-8,6.32-15.16C1085.13,1153.6,1083.09,1150.36,1078.61,1153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1097.94,1167.17c-5.76,3.42-8.58-.16-8.69-9-.12-8.68,2.56-15.76,8.31-19.18s8.58.38,8.69,9.06C1106.37,1156.88,1103.69,1163.74,1097.94,1167.17Zm-.34-25.44c-4.48,2.66-6.4,8.26-6.31,15.19.09,7.12,2.13,10.13,6.61,7.46s6.41-8,6.31-15.15C1104.12,1142.3,1102.08,1139.06,1097.6,1141.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1125.43,1150.8c-5.76,3.43-8.58-.15-8.69-9-.12-8.68,2.55-15.76,8.31-19.19s8.58.38,8.69,9.07C1133.86,1140.52,1131.18,1147.38,1125.43,1150.8Zm-.34-25.44c-4.48,2.67-6.4,8.27-6.31,15.19.09,7.13,2.13,10.13,6.61,7.47s6.41-8,6.31-15.16C1131.61,1125.93,1129.57,1122.7,1125.09,1125.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1144.41,1139.5c-5.75,3.43-8.57-.16-8.69-9-.11-8.68,2.56-15.76,8.32-19.19s8.57.38,8.69,9.06C1152.85,1129.22,1150.17,1136.08,1144.41,1139.5Zm-.33-25.44c-4.48,2.67-6.41,8.27-6.31,15.19.09,7.13,2.13,10.13,6.61,7.47s6.41-8,6.31-15.16C1150.6,1114.63,1148.55,1111.39,1144.08,1114.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1163.4,1128.2c-5.75,3.42-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.32-19.18s8.57.38,8.69,9.06C1171.84,1117.91,1169.16,1124.77,1163.4,1128.2Zm-.34-25.44c-4.47,2.66-6.4,8.26-6.31,15.19.1,7.12,2.14,10.13,6.62,7.46s6.4-8,6.31-15.15C1169.59,1103.33,1167.54,1100.09,1163.06,1102.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1182.39,1116.9c-5.75,3.42-8.57-.16-8.69-9-.12-8.68,2.56-15.76,8.32-19.19s8.57.39,8.69,9.07C1190.83,1106.61,1188.15,1113.47,1182.39,1116.9Zm-.34-25.45c-4.47,2.67-6.4,8.27-6.31,15.2.09,7.12,2.14,10.13,6.61,7.46s6.41-8,6.32-15.16C1188.58,1092,1186.53,1088.79,1182.05,1091.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1714.88,1154.48c-3-12.46-19.82-19.91-19.82-19.91l-17.45-8.92-54.12,40C1580.77,1183,1512,1212,1505,1216.63c-10,6.64-76.44,71.91-90.4,85.47s-24.5,30.37-28.53,33.6-2.78,1.34-12.28,15.84c-1.84,2.8-3.21,5-4.25,6.71h-52.49c.5-4.18.39-7.79-.72-10.09-4.75-9.9-33.54-39.81-54-41.14-7.35-.48-18.09-1.71-29.23-2.92l-62-35.84L1144.43,1280s-10.91,10.56-10.91,26.2c0,12.76,4.81,20.24,14.53,25.7s19.83,10.09,19.83,10.09l103.06,51.69,25.18,12.14a50.69,50.69,0,0,0,48.14-2.21l39.84-24L1693,1194.36a144.39,144.39,0,0,0,13-10C1715,1176.91,1717.87,1166.94,1714.88,1154.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1714.73,1154.52c-3-12.47-19.82-19.91-19.82-19.91l-24.19-.94-47.38,32.07c-42.72,17.26-111.49,46.26-118.47,50.92-10,6.65-76.44,71.92-90.39,85.48s-24.51,30.36-28.54,33.59-2.78,1.34-12.28,15.84c-1.84,2.8-3.21,5-4.25,6.72h-52.49c.5-4.19.39-7.79-.72-10.09-4.74-9.91-33.54-39.82-54-41.15-7.35-.47-18.09-1.7-29.23-2.92l-59-28.65-29.65,4.58s-10.91,10.56-10.91,26.19c0,12.76,4.82,20.24,14.53,25.7s19.83,10.1,19.83,10.1l103.06,51.68,25.18,12.15a50.69,50.69,0,0,0,48.14-2.22l39.84-24L1692.8,1194.4a147.08,147.08,0,0,0,13-10C1714.86,1177,1717.72,1167,1714.73,1154.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1714.88,1154.52c-3-12.47-19.82-19.91-19.82-19.91l-29.92.3-41.65,30.83C1580.77,1183,1512,1212,1505,1216.66c-10,6.65-76.44,71.92-90.4,85.48s-24.5,30.36-28.53,33.59-2.78,1.34-12.28,15.84c-1.84,2.8-3.21,5-4.25,6.72h-52.49c.5-4.19.39-7.79-.72-10.09-4.75-9.91-33.54-39.82-54-41.15-7.35-.47-18.09-1.7-29.23-2.92l-58.86-24.77-29.79.7s-10.91,10.56-10.91,26.19c0,12.76,4.81,20.24,14.53,25.7s19.83,10.1,19.83,10.1l103.06,51.68,25.18,12.15a50.69,50.69,0,0,0,48.14-2.22l39.84-24L1693,1194.4a147.08,147.08,0,0,0,13-10C1715,1177,1717.87,1167,1714.88,1154.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1150.16,1275.33l349.59-209.87a51.5,51.5,0,0,1,48.94-2.2l142.72,69.07a20.51,20.51,0,0,1,1.63,36l-347.5,209a50.67,50.67,0,0,1-48.13,2.21l-142.67-68.82C1136.41,1301.14,1137,1283.23,1150.16,1275.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1163.11,1277.85l178.72,84.86a9.34,9.34,0,0,0,8.77-.41l320.36-191a3.06,3.06,0,0,0-.22-5.38l-178.26-86.75a8.38,8.38,0,0,0-8,.35l-321.63,193.36A2.8,2.8,0,0,0,1163.11,1277.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1167.7,1276.92l321.63-193.37a8.38,8.38,0,0,1,8-.35L1675.56,1170a2.94,2.94,0,0,1,.91.71,3.06,3.06,0,0,0-.91-4.83l-178.25-86.76a8.38,8.38,0,0,0-8,.35L1167.7,1272.79a2.81,2.81,0,0,0-.44,4.48A2.51,2.51,0,0,1,1167.7,1276.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1414.07,1344.06a3.57,3.57,0,0,0-2.59.33h0l-27.42,16.48h0a6.64,6.64,0,0,0-2.87,4c-.84,3.09.34,6.1,2.64,6.73a3.56,3.56,0,0,0,2.53-.3h0l.24-.14L1413.5,1355h0a6.41,6.41,0,0,0,3.21-4.18C1417.56,1347.7,1416.37,1344.69,1414.07,1344.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1415.26,1344.86a3.57,3.57,0,0,0-2.59.32h0l-27.43,16.48h0a6.59,6.59,0,0,0-2.86,4c-.85,3.09.34,6.1,2.64,6.73a3.53,3.53,0,0,0,2.52-.3h0c.08,0,.15-.1.24-.14l26.87-16.17h0a6.42,6.42,0,0,0,3.22-4.18C1418.74,1348.5,1417.56,1345.48,1415.26,1344.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1229.1,1323.55l.8-.5a3.24,3.24,0,0,1,3-.12L1260,1336a.86.86,0,0,1,0,1.43l-.75.5a3.22,3.22,0,0,1-3,.11l-27.09-12.86A.93.93,0,0,1,1229.1,1323.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1227.46,1321c0,.9-1.18,1.62-2.64,1.62s-2.64-.72-2.64-1.62,1.19-1.62,2.64-1.62S1227.46,1320.1,1227.46,1321Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1168.27,1277.85,1347,1362.71a9.34,9.34,0,0,0,8.77-.41l320.36-191a3.06,3.06,0,0,0-.23-5.38l-178.25-86.75a8.38,8.38,0,0,0-8,.35L1168,1272.92A2.8,2.8,0,0,0,1168.27,1277.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1606.12,1118.53l-23.61-11.4c-1.67-.81-1.49-2.4.4-3.55l10.89-6.62a7.65,7.65,0,0,1,6.46-.62l23.61,11.41c1.67.81,1.5,2.4-.4,3.55l-10.89,6.62A7.61,7.61,0,0,1,1606.12,1118.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1582.9,1105.78l10.89-6.62a7.66,7.66,0,0,1,6.46-.62l23.61,11.41a2.26,2.26,0,0,1,.66.46,1.58,1.58,0,0,0-.66-2.66l-23.61-11.41a7.66,7.66,0,0,0-6.46.62l-10.89,6.62c-1.58,1-1.94,2.22-1.05,3.09A4.16,4.16,0,0,1,1582.9,1105.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1164.3,1243.85,1343,1328.71a9.34,9.34,0,0,0,8.77-.42l320.36-191a3.05,3.05,0,0,0-.23-5.37l-178.25-86.76a8.38,8.38,0,0,0-8,.35l-321.63,193.37A2.8,2.8,0,0,0,1164.3,1243.85Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1411.78 1262.6 1355.04 1230.41 1355.06 1196.94 1411.8 1229.14 1411.78 1262.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1466.26 1231.2 1411.8 1200.78 1466.28 1197.57 1466.26 1231.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1423.17 1115.72 1423.13 1181.31 1483.38 1160.33 1520.88 1099.87 1486.35 1071.55 1423.17 1115.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1423.23 1018.19 1423.19 1074.91 1495 1042.71 1506.57 986.62 1472 978.33 1423.23 1018.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1329.35 966.59 1355.21 951.68 1411.95 983.88 1386.1 998.79 1329.35 966.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "1466.43 952.64 1409.69 920.44 1383.2 935.55 1439.94 967.75 1466.43 952.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "1511.36 939.12 1457.17 908 1439.96 926.25 1498.19 950.42 1511.36 939.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "1355.23 918.22 1411.98 950.42 1411.95 983.88 1355.21 951.68 1355.23 918.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "1409.71 886.82 1466.45 919.02 1466.43 952.64 1409.69 920.44 1409.71 886.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1437.7 870.68 1494.44 902.88 1466.45 919.02 1409.71 886.82 1437.7 870.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1383.22 902.09 1439.96 934.29 1411.98 950.42 1355.23 918.22 1383.22 902.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1466.26,1231.2l0-33.63q-7.92,4.73-17.7,10.37l-8.79,5.07,0,33.46-28,16.13,0-33.46-25.86,14.91.16-245.26L1412,983.88l0-33.46,28-16.13,0,33.46,19.71-11.36c2.34-1.36,4.6-2.6,6.78-3.75l0-33.62,28-16.14,0,36.47q9.4-2.75,16.94-.23,8.54,2.77,14.17,12.31t5.63,25.44a100.61,100.61,0,0,1-7,35.64,109.61,109.61,0,0,1-18.9,32.47q16.82-3.17,25.85,7.34t9,31.77a123.73,123.73,0,0,1-5.86,35.9,132.24,132.24,0,0,1-16,34.57,99.53,99.53,0,0,1-24,25.37l0,35.13Zm-43.09-115.48,0,65.59,34.39-19.83q20.07-11.58,25.48-16.19a51,51,0,0,0,13.49-17.57,54,54,0,0,0,5.23-23.84q0-11-4-16.41t-11.61-4.52q-7.59.85-32.94,15.48Zm.06-97.53,0,56.72,24.35-14q21.7-12.52,27-16.4a50.48,50.48,0,0,0,15-17.43,47.36,47.36,0,0,0,5.46-22.3q0-11.37-4.69-15.77t-14-.55q-5.52,2.34-31.76,17.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "1329.35 966.59 1386.1 998.79 1385.94 1244.05 1329.2 1211.85 1329.35 966.59"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1478.88,1240l0-33.63q-7.9,4.74-17.7,10.37l-8.79,5.07v33.46l-28,16.14,0-33.46-25.86,14.9.15-245.25,25.86-14.91,0-33.46,28-16.14,0,33.46,19.71-11.36q3.51-2,6.78-3.75l0-33.62,28-16.13,0,36.46q9.42-2.75,16.94-.22,8.54,2.76,14.18,12.31t5.63,25.43a100.53,100.53,0,0,1-7,35.64,109.86,109.86,0,0,1-18.91,32.47q16.81-3.17,25.85,7.34t9,31.77a124,124,0,0,1-5.85,35.9,132.48,132.48,0,0,1-16,34.58,99.65,99.65,0,0,1-24,25.37l0,35.13Zm-43.08-115.47,0,65.58,34.39-19.83q20.08-11.57,25.48-16.19a50.73,50.73,0,0,0,13.5-17.56,54.15,54.15,0,0,0,5.23-23.84q0-11-4-16.42t-11.6-4.52q-7.59.87-33,15.48Zm0-97.54,0,56.72,24.35-14q21.7-12.51,27-16.39a50.44,50.44,0,0,0,15-17.44,47.32,47.32,0,0,0,5.46-22.29q0-11.38-4.69-15.78t-14-.55q-5.52,2.36-31.75,17.47Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-101",
    cx: 1039.31,
    cy: 826.79,
    rx: 777.27,
    ry: 777.64,
    transform: "translate(-65.6 1563.61) rotate(-72.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-102",
    cx: 1078.94,
    cy: 772.37,
    r: 777.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 567.65,
    cy: 1456.12,
    r: 56.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 1558.57,
    cy: 270.81,
    r: 67.36
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImage);
export default __webpack_public_path__ + "static/media/auth-image.b96dc8660f4588b9425d1a637a610ce5.svg";
export { ForwardRef as ReactComponent };